import { layoutTargets } from './layoutTargets';
import { preview } from './preview';

export const AdjacentLeftOnly = {
  layoutTargets,
  preview,
};
